import { render, staticRenderFns } from "./PaginationTemplate.vue?vue&type=template&id=7000f772"
import script from "./PaginationTemplate.vue?vue&type=script&lang=js"
export * from "./PaginationTemplate.vue?vue&type=script&lang=js"
import style0 from "./PaginationTemplate.vue?vue&type=style&index=0&id=7000f772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports